import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { locationsApi, useMutationLocation } from '../../api/locations.js';
import { galerieALaction } from '../../auth/sujet.js';
import { useShellContext } from '../shell/context.js';
import { ContratForm } from './ContratForm.js';
import styles from './Locations.module.css';

export function NouvelleLocationPage() {
  const { t } = useTranslation('regie');
  const { galerieSlug, galerie } = useShellContext();
  const naviguer = useNavigate();
  const creer = useMutationLocation(
    galerieSlug,
    (corps: Parameters<typeof locationsApi.creer>[1], appel) =>
      locationsApi.creer(galerieSlug, corps, appel),
  );
  if (!galerieALaction(galerie, 'locations:write')) return <p>{t('locations.accesRefuse')}</p>;
  return (
    <section className={styles.page}>
      <h1>{t('locations.nouveau')}</h1>
      <ContratForm
        galerieSlug={galerieSlug}
        enCours={creer.isPending}
        onSoumettre={async (corps) => {
          const r = await creer.mutateAsync(corps);
          void naviguer(`/${galerieSlug}/locations/${r.contrat.id}`);
        }}
      />
    </section>
  );
}
